export default __webpack_public_path__ + "static/media/2014_image.6f795b72.png";